import { makeStyles } from "@material-ui/core/styles"

export const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(3)
  }
}))

export default { useStyles }
